package com.klantenstop.web.data.models.dto.requests.address

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateAddress(
    @SerialName("street_name")
    val streetName: String? = null,
    @SerialName("street_number")
    val streetNumber: String? = null,
    @SerialName("zip_code")
    val zipCode: String? = null,
    val city: String? = null,
    val province: String? = null,
    val country: String? = null,
    val latitude: Double? = null,
    val longitude: Double? = null
)
